import { getDomainOrigin, getAxiosConfig } from 'utils/serverConfig';
import axios from 'axios';
import { IPaymentOption, IPaymentOptionsResponse } from './types';

export const getOrderByOrderEkey = async (
    partnerId: string,
    order_ekey: string | string[] | undefined
) => {
    try {
        const { status, data } = await axios({
            method: 'GET',
            url: `${getDomainOrigin()}/api/mpos/partner/${partnerId}/order`,
            params: {
                order_ekey,
                user_type: 'DEALER',
                page: 0,
                size: 1,
            },
            ...getAxiosConfig(),
        });
        if (status === 200 && data) {
            return {
                status: true,
                data,
            };
        }
        return {
            status: false,
        };
    } catch (e: any) {
        if (e?.response?.status === 401) {
            return {
                statusCode: 401,
                status: false,
            };
        }
        return {
            status: false,
        };
    }
};

export const dealerPayment = async (
    partnerId: string,
    order_ekey: string | string[] | undefined
) => {
    try {
        const { status, data } = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/partner/${partnerId}/payment`,
            data: {
                user_type: 'dealer',
                order_ekey,
            },
            ...getAxiosConfig(),
        });
        if (status === 200 && data) {
            return {
                data,
                status: true,
            };
        }
        return {
            status: false,
        };
    } catch (e: any) {
        if (e?.response?.status === 401) {
            return {
                statusCode: 401,
                status: false,
            };
        }
        return {
            status: false,
        };
    }
};

export const getAllPaymentOptions = async (
    partnerId: string,
    group: string
): Promise<IPaymentOptionsResponse> => {
    try {
        const { status, data } = await axios({
            method: 'GET',
            url: `${getDomainOrigin()}/api/mpos/partner/${partnerId}/payment/options?group_name=${group}`,
            ...getAxiosConfig(),
        });

        if (status === 200 && data) {
            const applicablePaymentOptions = data.filter(
                (paymentOption: IPaymentOption) => paymentOption.applicable
            );
            return {
                data: applicablePaymentOptions,
                status: true,
                statusCode: 200,
            };
        }
        return {
            data: [],
            status: false,
            statusCode: status,
        };
    } catch (e: any) {
        if (e?.response?.status === 401) {
            return {
                data: [],
                status: false,
                statusCode: 401,
            };
        }
        if (e?.response?.status === 400) {
            return {
                data: [],
                status: false,
                errorMessage: e.response.message || 'Something went wrong',
                statusCode: 400,
            };
        }
        return {
            data: [],
            status: false,
            errorMessage: e.response.message || 'Something went wrong',
            statusCode: 500,
        };
    }
};
